"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var StyledComponets_1 = require("./StyledComponets");
var Actions = function (_a) {
    var value = _a.value, setValue = _a.setValue;
    return (react_1["default"].createElement(box_1["default"], { padding: "0", style: { display: 'grid', flex: 1, alignContent: 'baseline' } },
        react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold", color: "black.haptik" }, "Instructions"),
        react_1["default"].createElement(StyledComponets_1.StyledText, { marginBottom: "16px" }, "These are the instructions your agent will follow to complete the task. They guide the agent on which tools to use, how to use them, and when to apply them."),
        react_1["default"].createElement(StyledComponets_1.StyledTextInput, { value: value, onChange: setValue, themed: true, multiline: true, placeholder: "Please enter your system prompt here.", autoExpand: true, maxHeight: 500 })));
};
exports["default"] = Actions;
